
  export default {
    props: {
      number: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
  };
